import type {SeedQuestion, SeedQuestionStatus} from '@cp/model';
import {useCallback, useState} from 'react';
import listSeedQuestionsDoc from '../../api/seedQuestion/listSeedQuestionsDoc';

export interface ListSeedQuestionsVariables {
  moduleId: string;
  topic?: string;
  status?: SeedQuestionStatus;
  limit?: number;
  offset?: number;
}

export function useListSeedQuestions() {
  const [seedQuestions, setSeedQuestions] = useState<SeedQuestion[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);

  const fetchSeedQuestions = useCallback(async (variables: ListSeedQuestionsVariables) => {
    setLoading(true);
    setError(undefined);
    try {
      const rows = await listSeedQuestionsDoc(variables);
      setSeedQuestions(rows);
      return rows;
    } catch (err) {
      const e = err instanceof Error ? err : new Error(String(err));
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    seedQuestions,
    loading,
    error,
    fetchSeedQuestions,
    /** Same as `fetchSeedQuestions` (Firestore list has no separate cache refetch). */
    refetchSeedQuestions: fetchSeedQuestions,
  };
}
